export const CompletedListData =[
   {
    disputeId: "DSP-2001",
    id: 1,
    referenceNo: "REF-900101",
    customerName: "Anjali Gurung",
    accountNumber: "1122334455",
    branchName: "New Baneshwor",
    disputeType: "ATM Withdrawal Issue",
    transactionDate: "2025-09-15",
    initiatedDate: "2025-09-16",
    completedDate: "2025-09-20",
    amount: 12000,
    status: "Resolved",
    remarks: "Double debit refunded",
    resolvedBy: "admin01",
  },
  {
    disputeId: "DSP-2002",
    id: 2,
    referenceNo: "REF-900102",
    customerName: "Ramesh Thapa",
    accountNumber: "2233445566",
    branchName: "Kalimati",
    disputeType: "POS Transaction Failure",
    transactionDate: "2025-09-17",
    initiatedDate: "2025-09-18",
    completedDate: "2025-09-22",
    amount: 7500,
    status: "Resolved",
    remarks: "Merchant credited successfully",
    resolvedBy: "officer02",
  },
  {
    disputeId: "DSP-2003",
    id: 3,
    referenceNo: "REF-900103",
    customerName: "Sita Lama",
    accountNumber: "3344556677",
    branchName: "Tripureshwor",
    disputeType: "Fund Transfer Delay",
    transactionDate: "2025-09-12",
    initiatedDate: "2025-09-13",
    completedDate: "2025-09-19",
    amount: 20000,
    status: "Resolved",
    remarks: "Funds successfully transferred",
    resolvedBy: "officer01",
  },
  {
    disputeId: "DSP-2004",
    id: 4,
    referenceNo: "REF-900104",
    customerName: "Prakash Shrestha",
    accountNumber: "4455667788",
    branchName: "Jawalakhel",
    disputeType: "UPI Transaction Issue",
    transactionDate: "2025-09-20",
    initiatedDate: "2025-09-21",
    completedDate: "2025-09-25",
    amount: 5000,
    status: "Resolved",
    remarks: "Transaction corrected and refunded",
    resolvedBy: "admin02",
  },
  {
    disputeId: "DSP-2005",
    id: 5,
    referenceNo: "REF-900105",
    customerName: "Bibek Karki",
    accountNumber: "5566778899",
    branchName: "Thamel",
    disputeType: "Cheque Cleared Incorrectly",
    transactionDate: "2025-09-10",
    initiatedDate: "2025-09-11",
    completedDate: "2025-09-18",
    amount: 45000,
    status: "Resolved",
    remarks: "Cheque corrected and amount refunded",
    resolvedBy: "officer03",
  },
]